export default __webpack_public_path__ + "static/media/tuto_kingdom_4_3x.c0f65e75.webp";